import type CelebrationObject from '../schema/CelebrationObject';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import { getDefaultColor } from 'owa-color-utils/lib/colorUtils';
import { getPalette } from 'owa-theme';

export default function changeCelebrationImageColor(
    colorScheme: ColorScheme,
    celebrationObject: CelebrationObject
) {
    if (celebrationObject?.image) {
        let svgText = celebrationObject.image;
        const defaultColor = getDefaultColor();
        let correctColorSvgText = colorScheme
            ? svgText.replace(defaultColor, colorScheme.calPrimary)
            : svgText.replace(defaultColor, getPalette().themePrimary);

        return { __html: correctColorSvgText };
    }

    return null;
}
